import { Navigate, Route, Routes } from 'react-router-dom';
import { PortalLoginPage, PortalResetPasswordPage } from './PortalAuthPages.js';
import { PortalInvoicePage, PortalInvoicesPage, PortalStatementPage } from './PortalFinancePages.js';
import { PortalSessionProvider } from './PortalSession.js';
import { RequirePortalSession } from './PortalShell.js';
import {
  PortalReportPage,
  PortalReportsPage,
  PortalWorkOrderPage,
  PortalWorkOrdersPage,
} from './PortalWorkPages.js';

/**
 * The client portal — Phase 11 (D146). Mounted once, at `/portal/*`, by
 * `app/App.tsx`, and otherwise self-contained: its own session, shell, API
 * client and guard. Nothing here reads the staff session.
 */
export function PortalApp() {
  return (
    <PortalSessionProvider>
      <Routes>
        <Route path="login" element={<PortalLoginPage />} />
        <Route path="reset-password" element={<PortalResetPasswordPage />} />
        <Route element={<RequirePortalSession />}>
          <Route index element={<PortalWorkOrdersPage />} />
          <Route path="requests/:id" element={<PortalWorkOrderPage />} />
          <Route path="reports" element={<PortalReportsPage />} />
          <Route path="reports/:id" element={<PortalReportPage />} />
          <Route path="invoices" element={<PortalInvoicesPage />} />
          <Route path="invoices/:id" element={<PortalInvoicePage />} />
          <Route path="statement" element={<PortalStatementPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/portal" replace />} />
      </Routes>
    </PortalSessionProvider>
  );
}
